import { Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyled = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
  height: "100%",
  maxWidth: "1440px",
  padding: "0 100px",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 24px",
    alignSelf: "stretch",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "48px 16px",
  },
}));

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  alignSelf: "stretch",
  flexShrink: "0",
  margin: "auto",
  gap: "40px",
  height: "100%",
  maxHeight: "unset",
  width: "100%",
  overflow: "visible",
  backgroundColor: "#FAFAFA",
  position: "relative",
  padding: "80px 100px",

  /* Hide scrollbar for Chrome, Safari and Opera */
  "&::-webkit-scrollbar": {
    display: "none",
  },
  /* Hide scrollbar for IE, Edge and Firefox */
  "-ms-overflow-style": "none", // IE and Edge
  "scrollbar-width": "none", // Firefox

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "column",
    maxHeight: "unset",
    padding: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "16px",
    flexDirection: "row",
    maxHeight: "unset",
    overflow: "unset",
  },
}));

export const OuterContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "row",
  // padding: "80px 100px",
  gap: "36px",
  alignItems: "center",
  alignSelf: "stretch",
  maxHeight: "unset",
  height: "100%",
  maxWidth: "1440px",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // padding: "40px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    // padding: "40px 16px",
    flexDirection: "column",
    maxHeight: "unset",
    overflow: "auto",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  padding: "24px",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  flex: "1 0 0",
  alignSelf: "stretch",
  borderRadius: "8px",
  background: "#EEEEF0",

  [props.theme.breakpoints.down("lg")]: {
    gap: "16px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: props?.cardNumber === 0 ? "100%" : "50%",
    minWidth: props?.cardNumber === 0 ? "100%" : "unset",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  position: "absolute",
  borderRadius: "8px",
  maxHeight: "180px",
  maxWidth: "185px",
  objectFit: "cover",
  top: "10px",
  right: "0px",

  [props.theme.breakpoints.down("lg")]: {
    top: "0px",
    right: "40px",
    maxHeight: "140px",
    maxWidth: "140px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    top: "0px",
    right: "16px",
    maxHeight: "90px",
    maxWidth: "90px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  justifyContent: "flex-start",
  gap: "24px",
  flex: "1 0 0",
  width: "100%",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "16px",
    textAlign: "left",
  },
}));

export const CardText = styling(Typography)((props) => ({
  ...(props.type == "desc" && {
    fontFamily: "Inter",
    fontStyle: "normal",
    alignSelf: "stretch",
    color: "#261754",
    fontSize: "24px",
    fontWeight: 700,
    lineHeight: "32px",

    "& b": {
      color: "#512ACC",
    },
  }),

  [props.theme.breakpoints.down("lg")]: {
    ...(props.type == "desc" && {
      fontSize: "16px",
      lineHeight: "24px",
      letterSpacing: "0.15px",
    }),
  },

  [props.theme.breakpoints.down("tablet")]: {
    ...(props.type == "desc" && {
      alignItems: "center",
      fontSize: "14px",
      lineHeight: "21px",
    }),
  },
}));

export const CoverImageContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignContent: "center",
  maxWidth: "1240px",
  width: "100%",
  gap: "20px",
  borderRadius: "8px",
  overflow: "hidden",

  [props.theme.breakpoints.down("lg")]: {
    gap: "16px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "18px",
  },
}));

export const CoverImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  objectFit: "cover",
  borderRadius: "8px",
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "row",
  gap: "20px",
  alignItems: "center",
  alignSelf: "stretch",
  maxHeight: "unset",
  height: "100%",
  maxWidth: "1440px",

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "row",
    maxHeight: "unset",
    overflow: "auto",
    gap: "16px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "row",
    flexWrap: "wrap",
    maxHeight: "unset",
    gap: "8px",
  },
}));

export const CardBreak = styling("hr")((props) => ({
  height: "360px",
  width: "1px",
  border: "none",
  backgroundColor: "#AEAEAE",

  [props.theme.breakpoints.down("lg")]: {
    height: "1px",
    width: "calc(100% - 80px)",
  },

  [props.theme.breakpoints.down("tablet")]: {
    height: "1px",
    width: "calc(100% - 48px)",
  },
}));

export const CardIcon = styling("div")((props) => ({
  display: "flex",
  width: "40px",
  height: "40px",

  "& svg": {
    width: "40px",
    height: "40px",
  },

  [props.theme.breakpoints.down("lg")]: {
    width: "20px",
    height: "20px",
    "& svg": {
      width: "20px",
      height: "20px",
    },
  },
}));
